// extracted by mini-css-extract-plugin
export default {"container":"ContactsBlock_container__OwOfp","title":"ContactsBlock_title__fxje5","button":"ContactsBlock_button__bm3bf"};